import { render, staticRenderFns } from "./confirm_email.vue?vue&type=template&id=4f73b71f&"
import script from "./confirm_email.vue?vue&type=script&lang=js&"
export * from "./confirm_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports